<nb-card>
  <!-- <nb-card-header>
    <h6 class="text-primary">{{ title }}</h6>
  </nb-card-header> -->

  <nb-card-body>
    <ngx-barcode
      [bc-value]="barcode"
      [bc-width]="1.6"
      [bc-height]="50"
      [bc-format]="'ean13'"
      [bc-element-type]="'svg'"
      [bc-display-value]="true"
      [bc-font]="'roboto'"
      [bc-margin]="0"
    ></ngx-barcode>

    <!-- <svg id="ean-13"></svg> -->
  </nb-card-body>
</nb-card>
